import { Component, Input, OnInit, SkipSelf, Host } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ConcessaoService } from '../../../../../../services/mob/concessao.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { VistoriaSearch } from '../../../../../../services/mob/vistoria.search';


@Component({
  selector: 'dropdown-concessao-taxi',
  templateUrl: './dropdown-concessao-taxi.component.html',
  styleUrls: ['./dropdown-concessao-taxi.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownConcessaoTaxiComponent implements OnInit {

  concessoes = []
  vistoriaSearch: VistoriaSearch
  formGroup: FormGroup;

  constructor(
    private _concessaoService: ConcessaoService,
    private _control: ControlContainer,
  ) { 
    
  }
  

  ngOnInit() {
    this.formGroup = this._control.control as FormGroup;
    this.load()

  }

  click(value = null){
    if(this.formGroup.get('cdPessoa')){
      this.formGroup.get('cdPessoa').setValue(value.concessao.cdConcessionario)
      this.formGroup.get('nrPlaca').setValue(value.nrPlaca)
      this.formGroup.get('cdVeiculo').setValue(value.concessao.cdVeiculo)
    }
    
  }

  
  load() {
    return this._concessaoService.findTaxi().then(r => {
      this.concessoes = r;
    });
  }

}
